import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

interface AddAddonParams {
  addonId: string;
  billingPeriod: string;
}

export const useAddAddonSubscription = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ addonId, billingPeriod }: AddAddonParams) =>
      subscriptionService.addAddonSubscription(addonId, billingPeriod),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizationSubscription'] });
      queryClient.invalidateQueries({ queryKey: ['addonSubscriptions'] });
      queryClient.invalidateQueries({ queryKey: ['totalIncludedSeats'] });
      queryClient.invalidateQueries({ queryKey: ['organizationTransactionHistory'] });
      toast.success(tActionMessages.addonAddedSuccessfully);
    },
    onError: (error: any) => {
      // Sprint 17, story-082: the typed "not linked to your plan" rejection is surfaced as an
      // inline banner by the calling component (AddAddonModal), not a toast — skip the generic
      // toast for that one code so the user doesn't see both.
      const code = error?.response?.errors?.[0]?.extensions?.code;
      if (code === 'ADDON_NOT_LINKED_TO_PLAN') {
        return;
      }
      toast.error(error?.response?.errors?.[0]?.message || tActionMessages.failedToAddAddon);
    },
  });
};
